import './../../scss/theme/components/download-module.scss';

window.addEventListener('DOMContentLoaded', () => {

  const swiper = new Swiper('.download-module_swiper', {
    // Optional parameters
    loop: true,
    spaceBetween: 50,
    autoHeight: false,
    speed: 500,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  const items = document.getElementsByClassName('download-item_title');

  if (Object.entries(items).length !== 0) {
    // Matches any file extension in item name string and replaces them with empty string.
    const regex = /\.\S+$/igm;

    for (const item of items) {
      item.innerText = item.innerText.replace(regex, '')
    }
  }

});



